import {formatPrice} from '../../../utils/common'
import {formatCountAndPrice} from '../utils'

export const parseSalesRepTypeReportRow = (row: any) => ({
  id: row.id,
  salesRepType: row.sales_rep_type || '-',
  order: row.total_order_count || 0,
  freeship: formatCountAndPrice(row.freeship_coupon_count, row.freeship_discount),
  sf_coupon: formatCountAndPrice(row.sf_coupon_count, row.sf_discount),
  sll: formatCountAndPrice(row.sll_coupon_count, row.sll_discount),
  five_percent_off: formatCountAndPrice(
    row['5offoneorder_coupon_count'],
    row['5offoneorder_discount']
  ),
  other_coupon: formatCountAndPrice(row.other_coupon_count, row.other_discount),
  couponCodeValue: formatPrice(row.total_discount, false) || 0,
  contributedCouponPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseCustomerTypeReportRow = (row: any) => ({
  id: row.id,
  customerType: row.customer_type || '-',
  order: row.total_order_count || 0,
  freeship: formatCountAndPrice(row.freeship_coupon_count, row.freeship_discount),
  sf_coupon: formatCountAndPrice(row.sf_coupon_count, row.sf_discount),
  sll: formatCountAndPrice(row.sll_coupon_count, row.sll_discount),
  five_percent_off: formatCountAndPrice(
    row['5offoneorder_coupon_count'],
    row['5offoneorder_discount']
  ),
  other_coupon: formatCountAndPrice(row.other_coupon_count, row.other_discount),
  couponCodeValue: formatPrice(row.total_discount, false) || 0,
  contributedCouponPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseCustomerGroupReportRow = (row: any) => ({
  id: row.id,
  customerGroupName: row.customer_group_name || '-',
  customerGroupId: row.customer_group_id || '-',
  order: row.total_order_count || 0,
  freeship: formatCountAndPrice(row.freeship_coupon_count, row.freeship_discount),
  sf_coupon: formatCountAndPrice(row.sf_coupon_count, row.sf_discount),
  sll: formatCountAndPrice(row.sll_coupon_count, row.sll_discount),
  five_percent_off: formatCountAndPrice(
    row['5offoneorder_coupon_count'],
    row['5offoneorder_discount']
  ),
  other_coupon: formatCountAndPrice(row.other_coupon_count, row.other_discount),
  couponCodeValue: formatPrice(row.total_discount, false) || 0,
  contributedCouponPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseSalesRepReportRow = (row: any) => ({
  id: row.id,
  salesRep: row.rep_name || '-',
  salesRepType: row.rep_type || '-',
  salesRepEmail: row.rep_email || '-',
  order: row.total_order_count || 0,
  freeship: formatCountAndPrice(row.freeship_coupon_count, row.freeship_discount),
  sf_coupon: formatCountAndPrice(row.sf_coupon_count, row.sf_discount),
  sll: formatCountAndPrice(row.sll_coupon_count, row.sll_discount),
  five_percent_off: formatCountAndPrice(
    row['5offoneorder_coupon_count'],
    row['5offoneorder_discount']
  ),
  other_coupon: formatCountAndPrice(row.other_coupon_count, row.other_discount),
  couponCodeValue: formatPrice(row.total_discount, false) || 0,
  contributedCouponPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseCouponCodeReportRow = (row: any) => ({
  id: row.id,
  couponCodeName: row.coupon_code || '-',
  couponCodeId: row.coupon_code_id || '-',
  order: row.total_order_count || 0,
  amount: formatPrice(row.total_discount, false) || 0,
  totalCustomerCount: row.total_customer_count || 0,
  contributedDiscountPercentage: row.contributed_discount_percentage
    ? `${row.contributed_discount_percentage}%`
    : '0%',
})

